<template>
  <div>
    <div class="list-item-content">
      <img class="list-item-content-icon"
          :src="iconUrl"
          @click="toggleAssociatedApps"/>

      <div class="list-item-content-title one-liner"
           @click="toggleAssociatedApps">
        {{ app.label }}

        <div class="list-item-content-subtitle"
             v-if="app.associated_applications">
          {{ `${app.associated_applications.length} ${$t("appSettings.appsGroup")}` }}
        </div>
      </div>

      <base-btn-group v-if="!supportsProtection"
                      button-allow
                      button-block
                      :state="state"
                      :disabled-all="disabled"
                      @click="changeAction" />

      <social-media-label v-else @click="openSocialMedia" />
    </div>

    <div>
      <transition name="slide">
        <associated-apps v-if="showAssociatedApps"
                        :apps="associatedApps"
                        :platform="app.platform" />
    </transition>
    </div>
  </div>
</template>

<script>
  import AssociatedApps from '@/components/Child/ChildAppSettings/AssociatedApps'
  import SocialMediaLabel from '@/components/Child/ChildSocialMedia/SocialMediaLabel'

  import analytics from '@/services/analytics.js'

  export default {
    components: {
      AssociatedApps,
      SocialMediaLabel
    },

    props: {
      childId: {
        type: String,
        required: true
      },

      app: {
        type: Object,
        required: true
      },

      disabled: {
        type: Boolean,
        default: false
      }
    },

    data: () => ({
      state: null,
      showAssociatedApps: false
    }),

    created() {
      this.initState()
    },

    computed: {
      ...mapGetters('children', {
        getAppSettings: 'getAppSettings'
      }),

      settings() {
        return this.getAppSettings(this.childId)
      },

      setting() {
        return this.settings.find(setting => setting.application_id === this.app.id)
      },

      iconUrl() {
        return this.app.icon_url
          ? this.app.icon_url
          : require(`@/assets/images/osPlaceholders/${this.app.platform}_app.svg`)
      },

      supportsProtection() {
        return _.has(this.app, 'social_media_app') && this.app.social_media_app
      },

      associatedApps() {
        return this.app.associated_applications || []
      }
    },

    methods: {
      initState() {
        this.state = this.setting ? this.setting.action : 'allow'
      },

      changeAction(action) {
        this.$emit('changeAction', {
          ...this.app,
          action
        })
      },

      toggleAssociatedApps() {
        this.showAssociatedApps = !this.showAssociatedApps
      },

      openSocialMedia() {
        analytics.sendEvent('Pk_ManageInSocMedia_AppStgs')

        this.showModal('socialMedia', {
          childId: this.childId
        })
      }
    },

    watch: {
      settings() {
        this.initState()
      },

      app() {
        this.initState()
      }
    }
  }
</script>